<div class="offcanvas-container">
  <div class="offcanvas-header">
    <h4 class="offcanvas-title">
      Edit {{ itemType }}: {{ itemType === "Document" ? name : linkName }}
    </h4>
    <button type="button" class="btn-close" (click)="onCancel()"></button>
  </div>

  <div class="offcanvas-body">
    <form #editForm="ngForm">
      <!-- Item Type -->
      <div class="mb-3">
        <div class="row">
          <div class="col-11">
            <label class="form-label">Item Type</label>
          </div>
          <div class="col-1 required">
            <div class="danger">*</div>
          </div>
        </div>
        <select
          class="form-select"
          [ngModel]="itemType"
          (ngModelChange)="itemType = $event"
          name="itemType"
          required
        >
          <option value="Document">Document</option>
          <option value="Link">Link</option>
        </select>
      </div>

      <!-- Document fields -->
      <ng-container *ngIf="itemType === 'Document'">
        <!-- Name Field -->
        <div class="mb-3">
          <div class="row">
            <div class="col-11">
              <label class="form-label">Name</label>
            </div>
            <div class="col-1 required">
              <div class="danger">*</div>
            </div>
          </div>
          <input
            type="text"
            class="form-control"
            [ngModel]="name"
            (ngModelChange)="name = $event"
            name="docName"
            required
            #docName="ngModel"
            [ngClass]="{
              'is-invalid': docName.invalid && (docName.touched || editForm.submitted)
            }"
          />
          <div
            *ngIf="docName.invalid && (docName.touched || editForm.submitted)"
            class="invalid-feedback"
          >
            Please enter a document name.
          </div>
        </div>

        <!-- File Field (New File is optional) -->
        <div class="mb-3">
          <div class="row">
            <div class="col-11">
              <label class="form-label">New File</label>
            </div>
            <div class="col-1 required">
              <div class="danger">*</div>
            </div>
          </div>
          <input
            type="file"
            class="form-control"
            (change)="onFileSelected($event)"
            name="file"
          />
          <small class="text-muted">
            Your current file remains unchanged; upload a new file only if
            you wish to replace it.
          </small>
        </div>

        <!-- Type Field -->
        <div class="mb-3">
          <div class="row">
            <div class="col-11">
              <label class="form-label">Type</label>
            </div>
            <div class="col-1 required">
              <div class="danger">*</div>
            </div>
          </div>
          <select
            class="form-select"
            [ngModel]="docType"
            (ngModelChange)="docType = $event"
            name="docType"
            required
            #docTypeField="ngModel"
            [ngClass]="{
              'is-invalid': docTypeField.invalid && (docTypeField.touched || editForm.submitted)
            }"
          >
            <option value="Adoption">Adoption</option>
            <option value="General">General</option>
          </select>
          <div
            *ngIf="docTypeField.invalid && (docTypeField.touched || editForm.submitted)"
            class="invalid-feedback"
          >
            Please select a type.
          </div>
        </div>

        <!-- Species Field -->
        <div class="mb-3">
          <div class="row">
            <div class="col-11">
              <label class="form-label">Species</label>
            </div>
            <div class="col-1 required">
              <div class="danger">*</div>
            </div>
          </div>
          <select
            class="form-select"
            [ngModel]="species"
            (ngModelChange)="species = $event"
            name="species"
            required
            #speciesField="ngModel"
            [ngClass]="{
              'is-invalid': speciesField.invalid && (speciesField.touched || editForm.submitted)
            }"
          >
            <option value="All">All</option>
            <option value="Dog">Dog</option>
            <option value="Cat">Cat</option>
          </select>
        </div>

        <!-- Life Stage Field -->
        <!-- <div class="mb-3">
          <div class="row">
            <div class="col-11">
              <label class="form-label">Life Stage</label>
            </div>
            <div class="col-1 required">
              <div class="danger">*</div>
            </div>
          </div>
          <select
            class="form-select"
            [(ngModel)]="lifeStage"
            name="lifeStage"
            required
            size="5"
            #lifeStageField="ngModel"
            [multiple]="species !== 'All'"
            (change)="onLifeStageChange()"
            [ngClass]="{
              'is-invalid': lifeStageField.invalid && (lifeStageField.touched || editForm.submitted)
            }"
          >
            <ng-container *ngIf="species === 'All'; else speciesSpecificDocStages">
              <option value="All">All</option>
            </ng-container>
            <ng-template #speciesSpecificDocStages>
              <ng-container *ngIf="species === 'Cat'">
                <option *ngFor="let option of catLifeStages" [value]="option.value">
                  {{ option.label }}
                </option>
              </ng-container>
              <ng-container *ngIf="species === 'Dog'">
                <option *ngFor="let option of dogLifeStages" [value]="option.value">
                  {{ option.label }}
                </option>
              </ng-container>
            </ng-template>
          </select>
          <div
            *ngIf="lifeStageField.invalid && (lifeStageField.touched || editForm.submitted)"
            class="invalid-feedback"
          >
            Please select a life stage.
          </div>
        </div> -->
      </ng-container>

      <!-- Link fields -->
      <ng-container *ngIf="itemType === 'Link'">
        <!-- Name Field -->
        <div class="mb-3">
          <div class="row">
            <div class="col-11">
              <label class="form-label">Name</label>
            </div>
            <div class="col-1 required">
              <div class="danger">*</div>
            </div>
          </div>
          <input
            type="text"
            class="form-control"
            [ngModel]="linkName"
            (ngModelChange)="linkName = $event"
            name="linkName"
            required
            #linkNameField="ngModel"
            [ngClass]="{
              'is-invalid': linkNameField.invalid && (linkNameField.touched || editForm.submitted)
            }"
          />
          <div
            *ngIf="linkNameField.invalid && (linkNameField.touched || editForm.submitted)"
            class="invalid-feedback"
          >
            Please enter a link name.
          </div>
        </div>

        <!-- Link URL Field -->
        <div class="mb-3">
          <div class="row">
            <div class="col-11">
              <label class="form-label">Link URL</label>
            </div>
            <div class="col-1 required">
              <div class="danger">*</div>
            </div>
          </div>
          <input
            type="text"
            class="form-control"
            [ngModel]="linkUrl"
            (ngModelChange)="linkUrl = $event"
            name="linkUrl"
            required
            #linkUrlField="ngModel"
            [ngClass]="{
              'is-invalid': linkUrlField.invalid && (linkUrlField.touched || editForm.submitted)
            }"
          />
          <div
            *ngIf="linkUrlField.invalid && (linkUrlField.touched || editForm.submitted)"
            class="invalid-feedback"
          >
            Please enter a link URL.
          </div>
        </div>

        <!-- Type Field -->
        <div class="mb-3">
          <div class="row">
            <div class="col-11">
              <label class="form-label">Type</label>
            </div>
            <div class="col-1 required">
              <div class="danger">*</div>
            </div>
          </div>
          <select
            class="form-select"
            [ngModel]="linkDocType"
            (ngModelChange)="linkDocType = $event"
            name="linkDocType"
            required
            #linkDocTypeField="ngModel"
            [ngClass]="{
              'is-invalid': linkDocTypeField.invalid && (linkDocTypeField.touched || editForm.submitted)
            }"
          >
            <option value="Adoption">Adoption</option>
            <option value="General">General</option>
          </select>
          <div
            *ngIf="linkDocTypeField.invalid && (linkDocTypeField.touched || editForm.submitted)"
            class="invalid-feedback"
          >
            Please select a type.
          </div>
        </div>

        <!-- Species Field -->
        <div class="mb-3">
          <div class="row">
            <div class="col-11">
              <label class="form-label">Species</label>
            </div>
            <div class="col-1 required">
              <div class="danger">*</div>
            </div>
          </div>
          <select
            class="form-select"
            [ngModel]="linkSpecies"
            (ngModelChange)="linkSpecies = $event"
            name="linkSpecies"
            required
            #linkSpeciesField="ngModel"
            [ngClass]="{
              'is-invalid': linkSpeciesField.invalid && (linkSpeciesField.touched || editForm.submitted)
            }"
          >
            <option value="" disabled>Select</option>
            <option value="All">All</option>
            <option value="Dog">Dog</option>
            <option value="Cat">Cat</option>
          </select>
        </div>

        <!-- Life Stage Field -->
        <!-- <div class="mb-3">
          <div class="row">
            <div class="col-11">
              <label class="form-label">Life Stage</label>
            </div>
            <div class="col-1 required">
              <div class="danger">*</div>
            </div>
          </div>
          <select
            class="form-select"
            [(ngModel)]="linkLifeStage"
            name="linkLifeStage"
            required
            size="5"
            #linkLifeStageField="ngModel"
            [multiple]="linkSpecies !== 'All'"
            (change)="onLinkLifeStageChange()"
            [ngClass]="{
              'is-invalid': linkLifeStageField.invalid && (linkLifeStageField.touched || editForm.submitted)
            }"
          >
            <ng-container *ngIf="linkSpecies === 'All'; else speciesSpecificLinkStages">
              <option value="All">All</option>
            </ng-container>
            <ng-template #speciesSpecificLinkStages>
              <ng-container *ngIf="linkSpecies === 'Cat'">
                <option *ngFor="let option of catLifeStages" [value]="option.value">
                  {{ option.label }}
                </option>
              </ng-container>
              <ng-container *ngIf="linkSpecies === 'Dog'">
                <option *ngFor="let option of dogLifeStages" [value]="option.value">
                  {{ option.label }}
                </option>
              </ng-container>
            </ng-template>
          </select>
          <div
            *ngIf="linkLifeStageField.invalid && (linkLifeStageField.touched || editForm.submitted)"
            class="invalid-feedback"
          >
            Please select a life stage.
          </div>
        </div> -->
      </ng-container>
    </form>
  </div>

  <div class="offcanvas-footer p-3 d-flex justify-content-end">
    <button type="button" class="btn secondaryBtn me-2" (click)="onCancel()">
      Cancel
    </button>
    <button type="button" class="primaryBtn" (click)="onSubmit(editForm)">
      Update
    </button>
  </div>
</div>
